import React from "react";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/lib/shadcn/ui/alert-dialog";
import { buttonVariants } from "@/lib/shadcn/ui/button";

export type DeleteOptionTypeLabel = "tag" | "municipality section" | "owner group" | "address";

export interface DeleteOptionConfirmDialogProps {
    optionTypeLabel: DeleteOptionTypeLabel;
    optionName: string;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    isDeleting: boolean;
}

export const DeleteOptionConfirmDialog: React.FC<DeleteOptionConfirmDialogProps> = ({
    optionTypeLabel,
    optionName,
    open,
    onOpenChange,
    onConfirm,
    isDeleting,
}) => {
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent data-testid="delete-option-confirm-dialog">
                <AlertDialogHeader>
                    <AlertDialogTitle>
                        Delete {optionTypeLabel} &apos;{optionName}&apos;?
                    </AlertDialogTitle>
                    <AlertDialogDescription>This cannot be undone.</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
                    <AlertDialogAction
                        className={buttonVariants({ variant: "destructive" })}
                        onClick={onConfirm}
                        disabled={isDeleting}
                    >
                        Delete
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default DeleteOptionConfirmDialog;
